import gql from 'graphql-tag';

export const CatchupLastViewedTimeQuery = gql`
	query CatchupLastViewedTimeQuery($contentId: ID!, $contentType: CatchupContentType!) {
		catchupGetLastViewedTime(contentId: $contentId, contentType: $contentType) {
			lastViewedTimeISO
		}
	}
`;
